import { render } from "./ApiKeysPage.vue?vue&type=template&id=03897a7b"
import script from "./ApiKeysPage.vue?vue&type=script&lang=js"
export * from "./ApiKeysPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__